import React, { useEffect } from "react";
import "./style.css";
import { LEFT_MENU_WIDTH, NotificationType, PaymentPages } from "./Utils";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import * as Locale from '@mui/material/locale';
import RenderContent from "./RenderContent";
import MainContent from "./MainContent";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader";
import {
  FEATURE_CUSTOM_PAYMENT,
  FEATURE_CUSTOM_REDUX,
} from "../../../constant";
import PackageList from "../payment/PackageList";
import { useTheme } from "@emotion/react";
import {
  Breadcrumbs,
  Link,
  Box,
  Paper,
  // Grid,
  useMediaQuery,
  Typography,
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import {
  setNotificationMessage,
  setPaymentSelectedPage,
} from "./payment-reducer/actions";
import { getBaseConfig, getStore, handlePaymentWindow } from "../../../Utils";
import { getMySubscription } from "../../paymentRequest";
import { setDeviceInfoMessage } from "../../../redux/tool-webjam-v2/actions";
import { socketOn } from "../../../../../../socket";
import { INFO_CODE } from "../../../custom/components/deviceInfoMessage";
import { connect } from "../../../../base/redux";
import { Constant } from "../../../../webjam/constant";
import Toast from "react-simple-toasts";
import ToastSnackbar from "./helperComponent/ToastSnackbar";
import { formatDate } from "./AbstractHelperComponent";
import { ct } from "../../../constant-Utils";
import { useMenuList } from "./Sidebar";
import i18next from "i18next";
import { Button } from "@material-ui/core";
import { PushSpinner } from "../../../custom/components/PushSpinner";

const drawerWidth = LEFT_MENU_WIDTH;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

let css = `.pay-dash-cont input {
    border : none !important;
    outline : none !important;
    box-shadow : none !important;
    background:none !important;
}`;

let welcomeCss = document.createElement("style");
welcomeCss.type = "text/css";
welcomeCss.appendChild(document.createTextNode(css));

document.getElementsByTagName("head")[0].appendChild(welcomeCss);

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "block",
  alignItems: "left",
  minHeight: "24px",
  // padding: theme.spacing(0, 1),
  // ...theme.mixins.toolbar,
  // justifyContent: 'flex-end',
}));

export const getTranslatedSubsName = (subsName="") => {
  if (subsName.toLowerCase() == 'basic') {
    return ct("rta-trmc.dashboard.subscription.basicText")
  } else if (subsName == 'Premium' || subsName == 'premiumText') {
    return ct("rta-trmc.dashboard.subscription.premiumText");
  } else {
    return "-";
  }
}


const PaymentModal = (props) => {
  const theme = useTheme();
  const locale = createTheme(
    theme,
    Locale[i18next.language],
  );
  // const [selectedTab, setSelectedTab] = React.useState(PaymentPages.INVITATION_LIST})
  const loadingShow = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX].showLoader
  );
  const { _menuList } = useMenuList();

  const handleBreadCrumb = (text) => {

    if (text === PaymentPages.CREATE_ROOM) {
      return ct("rta-trmc.dashboard.sideBarMenu.CREATE_ROOM");
    } else if (text === PaymentPages.UPDATE_ROOM) {
      return ct("rta-trmc.dashboard.sideBarMenu.UPDATE_ROOM");
    }

    _menuList.map(t => {
      if (t.children?.length) {
        const _t = t.children.find(_t => _t.enTitle === text);
        if (_t) {
          text = _t?.title;
        }
      }
      if (t?.enTitle === text) {
        text = t?.title;
      }
    });

    return text;
  }

  const {
    willShowPaymentDashboard,
    paymentSelectedPage,
    isLeftMenuOpen,
    userPaymentSubscription,
  } = useSelector((state) => state[FEATURE_CUSTOM_PAYMENT]);


  const [open, setOpen] = React.useState(false);

  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:600px)");
  let userLoginData = props.userLoginData;
  // useEffect(() => {
  //   socketOn("user_subscription", (data) => {
  //     let { windowRef } = getStore(FEATURE_CUSTOM_PAYMENT);
  //     console.log({ userLoginData, data }, "====>12345678990", windowRef);
  //     if (userLoginData.user) {
  //       try {
  //         // console.log("data user_id ", data.user_id, "user id ", userLoginData.user?.id)
  //         console.log(
  //           { userLoginData, data },
  //           "====>paymentconsole",
  //           windowRef
  //         );
  //         if (data.user_id == userLoginData.user?.id) {
  //           if (windowRef.package_id == data.package_id) {
  //             // setShowSubscription(false);
  //             dispatch(getMySubscription());
  //             // dispatch(setDeviceInfoMessage({
  //             //     show: true,
  //             //     messages: [],
  //             //     info_code: INFO_CODE.ALL_SET
  //             // }));
  //             windowRef.win.close();
  //           }
  //         }
  //       } catch (e) {
  //         Toast(
  //           "Something went wrong!",
  //           Constant?.App?.ToastTime?.LongCloseTime
  //         );
  //         console.log("socket error ", e);
  //       }
  //     }
  //   });
  // }, []);

  const StyledTypography = styled(Typography)({
    "&.MuiTypography-root": {
      fontSize: "16px",
      mb: 1,
      color: "#333",
    },
  });
  let curTime = Math.round(new Date().getTime() / 1000);

  const renderSubscriptionStatusDate = () => {
    if (userPaymentSubscription.is_refunded && userPaymentSubscription.refunded_at) {
      return (<>
        <StyledTypography
          sx={{
            color: "var(--theme-error-color) !important",
          }}
        >
          {ct("rta-trmc.dashboard.subscription.refundedOn")} :
        </StyledTypography>
        <StyledTypography
          sx={{
            color: "var(--theme-error-color) !important",
          }}
        >
          {formatDate(userPaymentSubscription.refunded_at, "YYYY-MM-DD")}
        </StyledTypography>
      </>)
    } else if (userPaymentSubscription.is_expired) {
      if (userPaymentSubscription.status == "past_due") {
        return (<>
          <StyledTypography
            sx={{
              color: "var(--theme-error-color) !important",
            }}
          >
            {ct("rta-trmc.dashboard.subscription.paymentDue")}
          </StyledTypography>
        </>)
      } else {
        return (<>
          <StyledTypography
            sx={{
              color: "var(--theme-error-color) !important",
            }}
          >
            {!userPaymentSubscription.is_canceled ? ct("Translate.typography.nxtInvoiceDate") : ct("Translate.typography.endDate")} :
          </StyledTypography>
          <StyledTypography
            sx={{
              color: "var(--theme-error-color) !important",
            }}
          >
            {formatDate(userPaymentSubscription.end_at, "YYYY-MM-DD")}
          </StyledTypography>
        </>)
      }
    } else {
      return (<>
        <StyledTypography
          sx={{
            color: "var(--theme-error-color) !important",
          }}
        >
          {!userPaymentSubscription.is_canceled ? ct("Translate.typography.nxtInvoiceDate") : ct("Translate.typography.endDate")} :
        </StyledTypography>
        <StyledTypography
          sx={{
            color: "var(--theme-error-color) !important",
          }}
        >
          {formatDate(userPaymentSubscription.end_at, "YYYY-MM-DD")}
        </StyledTypography>
      </>)
    }
  }

  return (
    <>
      <ToastSnackbar />
      <div className="main login">
        {loadingShow && (
          <>
            {getBaseConfig("showPushSpinnerLoader") ?
              <div className="loader-text-container E">
                <div className='loader-wrapper'>
                  <PushSpinner
                    size={30}
                    color="white"
                    loading={true}
                    className={"loader-text-main"}
                  />
                </div>
              </div>
              :
              <Loader
                loaded={false}
                options={{ color: "white" }}
              ></Loader>
            }
          </>
        )}
      </div>

      <div className={"pay-dash-cont"}>
        {willShowPaymentDashboard ? (
          <PackageList showPackageOnly={false} />
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                // height: isMobile ? "calc(100vh - 100px)" : undefined,
              }}
            >
              <MainContent />
              <Main open={isLeftMenuOpen} className={`${paymentSelectedPage.replace(/\s+/g, '-').toLowerCase()}-wrapper  w-100 subs-wrap`}>
                <DrawerHeader />
                <Grid container spacing={2} style={{ mt: 0 }} >
                  <Grid
                    className={`subscription-breadcrum ${isMobile ? "pb-0" : ""}`}
                    item
                    xs={12}
                    sm={12}
                    md={7}
                    lg={7}
                    style={{ marginTop: isMobile ? "20px" : "", marginLeft: isMobile ? "4px" : "" }}
                    classes={`subscription-breadcrum ${isMobile ? "pb-0" : ""}`}
                  >
                    <Paper
                      sx={{
                        // margin: "0 -10px",
                        padding: "20px",
                        borderRadius: 0,
                        background: "none",
                        boxShadow: "none",
                        paddingBottom:
                          isMobile &&
                            userPaymentSubscription.name &&
                            !userPaymentSubscription.is_canceled &&
                            paymentSelectedPage === "Subscription"
                            ? "0px"
                            : undefined,
                      }}
                    >
                      <Breadcrumbs
                        separator={<i className="fa fa-chevron-right"></i>}
                        aria-label="breadcrumb"
                        className="payment-breadcrumb"
                      >
                        <Link>{ct("rta-trmc.dashboard.subscription.home")}</Link>
                        {(paymentSelectedPage == PaymentPages.CREATE_ROOM ||
                          paymentSelectedPage == PaymentPages.UPDATE_ROOM) && (
                            <Link
                              onClick={() =>
                                dispatch(
                                  setPaymentSelectedPage(PaymentPages.HOSTED_ROOM)
                                )
                              }
                            >
                              {handleBreadCrumb(PaymentPages.HOSTED_ROOM)}
                            </Link>
                          )}
                        <Link>{handleBreadCrumb(paymentSelectedPage)}</Link>
                      </Breadcrumbs>
                    </Paper>
                  </Grid>
                  {userPaymentSubscription.name && curTime < userPaymentSubscription.end_at &&
                    paymentSelectedPage === "Subscription" && (
                      <Grid
                        className={`subs-end-info ${!isMobile ? "pull-right pl-0" : "pt-2 pl-5 pb-4"
                          }`}
                        style={{
                          alignSelf: "center",
                          display: "block",
                          alignItems: "center",
                          gap: "10px",
                          marginLeft: isMobile ? "10px" : "",
                        }}
                        item
                        xs={12}
                        sm={12}
                        md={5}
                        lg={5}
                      >
                        <div className="w-100">
                          <div
                            className={`w-100 d-flex justify-content-end`}
                            style={{
                              gap: "4px"
                            }}
                          >
                            <StyledTypography
                              sx={{
                                color: "var(--theme-error-color) !important",
                              }}
                            >
                              {ct("Translate.typography.subscription")} :
                            </StyledTypography>

                            <StyledTypography
                              sx={{
                                color: "var(--theme-error-color) !important",
                              }}
                            >
                              {" "}
                              {getTranslatedSubsName(userPaymentSubscription?.name)}
                            </StyledTypography>
                          </div>
                        </div>
                        <div className="w-100">
                          {userPaymentSubscription?.trial_ended &&
                            <div
                              className={`w-100 d-flex justify-content-end`}
                              style={{ gap: "4px" }}
                            >
                              <StyledTypography
                                sx={{
                                  color: "var(--theme-error-color) !important",
                                }}
                              >
                                {ct("Translate.typography.trailEndDate")} :
                              </StyledTypography>
                              <StyledTypography
                                sx={{
                                  color: "var(--theme-error-color) !important",
                                }}
                              >
                                {" "}
                                {formatDate(userPaymentSubscription.trial_ended, "YYYY-MM-DD")}
                              </StyledTypography>
                            </div>
                          }
                          <div
                            className={`w-100 d-flex justify-content-end`}
                            style={{ gap: "4px" }}
                          >
                            {renderSubscriptionStatusDate()}
                          </div>
                        </div>
                      </Grid>
                    )}

                  {
                    userPaymentSubscription.name && curTime > userPaymentSubscription.end_at && paymentSelectedPage === "Subscription" &&
                    <>
                      <Grid
                        className={`subs-end-info pt-0 ${!isMobile ? "pull-right pl-0" : "pt-2 pl-5 pb-4"
                          }`}
                        style={{
                          alignSelf: "center",
                          display: "block",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        item
                        xs={12}
                        sm={5}
                        md={4}
                        lg={5}
                        marginLeft={isMobile ? "10px" : ""}
                      >
                        <div className="w-100">

                          <div
                            className={`w-100 d-flex justify-content-end`}
                            style={{ gap: "4px" }}
                          >
                            <StyledTypography
                              sx={{
                                color: "var(--theme-error-color) !important",
                              }}
                            >
                              {ct("Translate.typography.subscription")} : {getTranslatedSubsName(userPaymentSubscription?.name)}
                            </StyledTypography>
                          </div>
                          <div
                            className={`w-100 d-flex justify-content-end`}
                            style={{ gap: "4px" }}
                          >
                            <StyledTypography
                              sx={{
                                color: "var(--theme-error-color) !important",
                              }}
                            >
                              {ct("rta-trmc.dashboard.subscription.expiredOn")} : {formatDate(userPaymentSubscription.end_at, "YYYY-MM-DD")}
                            </StyledTypography>
                          </div>
                          <div
                            className={`w-100 d-flex justify-content-end`}
                            style={{ gap: "4px" }}
                          >
                            {renderSubscriptionStatusDate()}
                          </div>
                        </div>
                      </Grid>
                    </>
                  }
                </Grid>
                {/* <Box
                  sx={{
                    flexGrow: 1,
                  }}
                > */}
                <Grid
                  item
                  xs={12}
                  lg={12}
                  className="lead-container tabs-content-outer"
                  style={{
                    borderRadius: 0,
                    boxShadow: "none",
                  }}
                >
                  <ThemeProvider theme={locale}>
                    <RenderContent selectedTab={paymentSelectedPage} />
                  </ThemeProvider>
                </Grid>
                {/* </Box> */}
              </Main>
            </Box>
          </>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
  };
};
export default connect(mapStateToProps)(PaymentModal);
